module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-mindfulness-skills@2x.82898ed3.png";